<template>
  <div></div>
</template>
<script setup>
import { getQueryString } from 'cupshe-utils'
import { loginSignIn } from '../Login/hook'
import { onMounted } from 'vue'
import { message } from 'ant-design-vue'
import { useStore } from 'vuex'
// 创建store对象
const store = useStore()

onMounted(() => {
  const code = getQueryString('code')
  if (code) {
    loginSignIn(
      {
        code,
        signPlatform: 'feishu'
      },
      result => {
        // iframe.style.opacity = 1
        message.error(`登录失败：${result.retInfo}`)
      },
      store
    )
  }
})
</script>
<style lang="scss" scoped></style>
